module.exports = __webpack_public_path__ + "assets/img/9dcde8d47bd25aa001a0e4a9109f2bc5.svg";